export const SCRIPTPAD_LOGO_URL =
  'https://cdn.prod.website-files.com/63887c351c5ad8c163bc4b10/643f7907e8ef29e96b3d1ed7_ScriptPadLogo_32H_WithInnerShadow.svg';

export const SCRIPTPAD_ICON_URL =
  'https://cdn.prod.website-files.com/63887c351c5ad8c163bc4b10/63888909f8dc5d4fd1ccba7c_ScriptPadLogo_Icon.png';
